import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { typePrefix } from '@redux/app/action'
import appRequest from '@apis/app'
import { LOCAL_STORAGE, SESSION_STORAGE } from '@utils/Const'
import { initDataDog, initTracking, isFacebookInAppBrowser } from '@utils'

const initialState = {
  app: [],
  userId: '',
  status: false,
}

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(appInit.pending, (state: any) => {
      state.isLoading = true
    })
    builder.addCase(appInit.fulfilled, (state: any, action: any) => {
      const userId = action.payload?.data?.user_id
      localStorage.setItem(LOCAL_STORAGE.USER_ID, userId)
      if (isFacebookInAppBrowser()) {
        if (userId) {
          const newUrl = new URL(window.location.href);
          newUrl.searchParams.set(LOCAL_STORAGE.USER_ID, userId);
          window.history.replaceState({}, '', newUrl);
        }
      }
      initTracking(userId)
      initDataDog(userId)
      state.userId = userId
      state.isLoading = false
    })
    builder.addCase(appInit.rejected, (state: any) => {
      state.data = []
      state.isLoading = false
    })
  },
})

export const appInit = createAsyncThunk(typePrefix.INIT_APP, async () => {
  const params: any = {}
  const urlParams = new URLSearchParams(window.location.search)
  const utmSource = urlParams.get(SESSION_STORAGE.UTM_SOURCE)
  const utmMedium = urlParams.get(SESSION_STORAGE.UTM_MEDIUM)
  const utmCampaign = urlParams.get(SESSION_STORAGE.UTM_CAMPAIGN)
  const referralUserId = urlParams.get('u')
  const referralAgent = urlParams.get('agt')

  if (utmSource) params.utm_source = utmSource
  if (utmMedium) params.utm_medium = utmMedium
  if (utmCampaign) params.utm_campaign = utmCampaign
  if (referralUserId) params.ref_user_id = referralUserId
  if (referralAgent) params.ref_agent_id = referralAgent
  const response = await appRequest.init(params)
  return response.data
})

export default appSlice.reducer
